// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_nL4","image":"Header_image__1f_kI","name":"Header_name__2E_j3","info":"Header_info__1g0hL","infoRow":"Header_infoRow__fmba0"};